import { forwardRef, type PropsWithChildren } from "react";

import { Circle, type CircleBadgeProps, type CircleProps } from "@eisox/design-system";
import { MultisensorIcon } from "@eisox/icons";

interface MultisensorProps extends CircleProps, PropsWithChildren {
  error?: CircleBadgeProps["variant"];
}

const Multisensor = forwardRef<HTMLDivElement, MultisensorProps>(
  ({ size = 20, backgroundColor = "blue", color = "white", children, error, ...props }, ref) => (
    <Circle.Root {...props} ref={ref} size={size} backgroundColor={backgroundColor} color={color}>
      {children ?? <MultisensorIcon />}
      {error && <Circle.Badge variant={error} />}
    </Circle.Root>
  ),
);

Multisensor.displayName = "Multisensor";

export default Multisensor;
export { Multisensor };
export type { MultisensorProps };
